class Payroll {
	async getPayrollList(companyId, month, year, countryId, status) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/salary/payroll_company/${companyId}?month=${month}&year=${year}&country=${countryId}&status=${status}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return await response.json()
	}

	async getEmployees(payrollId, levelId, areaId, name, limit, page) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/salary/payroll_employees/${payrollId}?level=${levelId}&area=${areaId}&name=${name}&limit=${limit}&page=${page}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return await response.json()
	}

	async getPayrollData(employeeId) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/payroll_data/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return await response.json()
	}

	async getGraphicData(companyId, levelId, areaId, name, limit, page) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/salary/payroll_graphics/${companyId}?level=${levelId}&area=${areaId}&name=${name}&limit=${limit}&page=${page}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return await response.json()
	}

	async getFileRoute(companyId, countryId, fileName, month, year) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/salary/payroll?companyId=${companyId}&countryId=${countryId}&fileName=${fileName}&month=${month}&year=${year}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return await response.json()
	}

	async sendFile(file, route) {
		const response = await fetch(route, {
			method: 'PUT',
			headers: {
				'Content-Type': file.type,
			},
			body: file,
		})

		if (!response.ok) {
			throw new Error(`Erro ao enviar o arquivo: ${response.statusText}`)
		}

		return response
	}

	async updateValidation(companyPayrollId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/payroll_validation/${companyPayrollId}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return await response.json()
	}

	async updatePayroll(payrollId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/payroll_update/${payrollId}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return await response.json()
	}
}
export default new Payroll()
